import { AuthenticatedTemplate } from "@azure/msal-react";
import { NavigationBar } from "./NavigationBar";
import { IubendaPolicies } from "./IubendaPolicies";

export const PageLayout = (props) => {
  return (
    <>
      <NavigationBar />
      <div className="mainContainer">
        {props.children}
        <br />
      </div>
      <footer>
        <center>
          © {new Date().getFullYear()} TechGuyDom all rights reserved. <br />
          <IubendaPolicies />
          <br />
        </center>
      </footer>
      <AuthenticatedTemplate />
    </>
  );
};
